import React, { useEffect, useRef, useState, useCallback } from "react";
import { FormWrapper } from "../../../components/form";
import PublicContentWrapper from "../../../layouts/public/index.style";
import { Card, Col, Form, Input, Layout, Row, Typography, Checkbox, Button, notification, message, Slider, InputNumber, Icon } from "antd";
import AsyncSelect from "react-select/async";
import { useMutation } from "react-apollo";
import debounce from "lodash/debounce";
import axios from "axios";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import whitelogo from "../../../assets/img/unitifi.svg";
import { apiUrl } from "../../../config";

const SearchClient = (props) => {
  const { history } = props;
  const [selectOrg, setOrg] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const selectInputRef = useRef();

  const [organizationSave, { data: orgData, loading: loadingSubmit, error: errorSubmit }] = useMutation(gql`
    mutation($id: Int, $utype: String) {
      organizationJoinRequestByUser(id: $id, utype: $utype) {
        ok
        error
        message
      }
    }
  `);

  const clientHandler = useCallback(
    debounce((inputText, callback) => {
      clientApiHandler(inputText).then((options) => callback(options));
    }, 1000),

    []
  );

  const clientApiHandler = async (input) => {
    if (input.trim().length <= 1) return;
    let result = await axios.get(`${apiUrl}/search-client/${input}`);
    result = result.data;
    if (result.length == 0) return;

    return result.map((data) => ({
      label: data.firstName,
      value: data.id,
      utype: data.utype,
    }));
  };

  useEffect(() => {
    if (!orgData) return;

    let data = orgData.organizationJoinRequestByUser;
    if (data.ok) {
      notification.success({ message: data.message});
      history.push("/settings/account");
    } else {
      notification.error({ message: data.error });
    }
  }, [orgData]);

  const orgSelectHandler = (data) => {
    setOrg(data);
    setError(false);
  };

  const submitHandler = () => {
    if (!selectOrg) {
      setError(true);
      return;
    }

    setLoading(true);
    organizationSave({ variables: { id: parseInt(selectOrg.value), utype: selectOrg.utype } });
    setLoading(false);
  };

  const onClear = () => {
    selectInputRef.current.clearValue();
    setOrg(null);
  };

  return (
    <PublicContentWrapper className="stretch-content ">
      <div className="search-organization-layout-wrapper">
        <FormWrapper className="public-form">
          <div>
            <div className="search-organization-header">
              <Link to="#" className="unitifi-logo">
                <img src={whitelogo} />
              </Link>
              <h5>Search For Your Organization</h5>
            </div>
            <Row gutter={16}>
              <Col className="gutter-row" span={24}>
                <Form.Item hasFeedback label={"Organization Name *"} style={{ color: "rgba(0, 0, 0, 0.85)", marginBottom: "10px" }}>
                  <AsyncSelect placeholder="Company/Practice Affiliation" ref={selectInputRef} loadOptions={clientHandler} onChange={(data) => orgSelectHandler(data)} className="unitifi-select-container" classNamePrefix="unitifi-react-select" />
                </Form.Item>
                {error && <p>Please select Organization</p>}
              </Col>
            </Row>
            {selectOrg && (
              <Row gutter={16}>
                <Col className="gutter-row" span={24}>
                  <p className="organization-error-remove-wrapper">
                    {selectOrg.label} <span onClick={() => onClear()}>X</span>
                  </p>
                </Col>
              </Row>
            )}

            <div className="organization-wrapper">
              {/* <Link to="/">Skip For Now</Link> */}
              <Button block type="primary" size="large" className="unitifi-login-btn request-btn" disabled={loading} loading={loading} onClick={() => submitHandler()}>
                Request to Join
              </Button>
            </div>
            <p className="organization-info-text">If you are unable to find your company or practice, this means they have yet to create an account. Please request your company or practice to create an account.</p>
          </div>
        </FormWrapper>
      </div>
    </PublicContentWrapper>
  );
};

export default SearchClient;
